import { FrequencyCadenceTypeEnum } from '@generated';

export interface FrequencyDetailsModel {
	id: string;
	scheduledDateAndTime: Date;
	frequencyCadenceTypeId: number;
	disciplineId: number;
	frequencyTypeId: number;
	frequencyStatusId: number;
}

export interface FrequencyDetailsWithCadenceModel extends FrequencyDetailsModel {
	dayWeekOrMonthNumber: number;
}

export interface AbbreviatedFrequencyModel {
	id: string;
	disciplineId: number;
	disciplineLabel: string;
	disciplineShortLabel: string;
	frequencyCadenceTypeId: number;
	frequencyTypeId: number;
	frequencyStartDate: Date;
	frequencyEndDate: Date;
	frequencies: FrequencyDetailsModel[];
	frequencyCount: number;
	frequencyCadenceCount: number;
	abbreviationLabel: string;
}

export const abbreviationCadences = [FrequencyCadenceTypeEnum.Daily, FrequencyCadenceTypeEnum.Weekly, FrequencyCadenceTypeEnum.Monthly];

export interface FrequencyDetailsGroupedByCadenceModel {
	disciplineId: number;
	frequencyCadenceTypeId: number;
	frequencyTypeId: number;
	dayWeekOrMonthNumber: number;
	frequencyStartDate: Date;
	frequencyEndDate: Date;
	frequencies: FrequencyDetailsModel[];
}
